import { render, staticRenderFns } from "./DossierHealthProviders.vue?vue&type=template&id=285b7ee0&scoped=true&"
import script from "./DossierHealthProviders.vue?vue&type=script&lang=js&"
export * from "./DossierHealthProviders.vue?vue&type=script&lang=js&"
import style0 from "./DossierHealthProviders.vue?vue&type=style&index=0&id=285b7ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b7ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
